<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	export let id = Math.random().toString(36).substring(0, 5);
	export let checked = false;
	export let disabled = false;
	export let label = '';
	export let placeholder = ''; // This might be bad practice, tying to unify the Input and CheckBox components
	export let value = false;
	export let name = '';
	export let customOnChange = () => {
		// If custom logic is needed when the checkbox changes, provide via this function
	};
</script>

<div class="container px-checkbox">
	<input type="checkbox" {id} {disabled} bind:checked bind:value {name} on:click={customOnChange} />
	<label for={id}>
		{#if label}
			{label}
		{/if}
		<div class="innerWrapper">
			<span class="checkWrapper">
				<Icon icon="check" size="18" />
			</span>
			<div>{placeholder}</div>
		</div>
	</label>
</div>

<style>
	.innerWrapper {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-block-start: var(--gutterSmaller);
		cursor: pointer;
	}

	.checkWrapper {
		display: block;
		block-size: 18px;
		inline-size: 18px;
		margin-inline-end: var(--gutterSmall);
		transition: all 100ms ease-out;
		border: 1px solid var(--inactiveBorderColor);
		border-radius: 2px;
		background-color: var(--inactiveBackgroundColor);
		line-height: 18px;
		text-align: center;
		user-select: none;
	}

	.checkWrapper :global(.px-icon) {
		block-size: 20px;
		opacity: 0;
		color: white;
		line-height: 16px;
		text-align: center;
	}

	input {
		display: none;
	}

	input:checked + label .checkWrapper {
		border-color: var(--primaryAccentColor);
		background-color: var(--primaryAccentColor);
	}

	input:checked + label .checkWrapper :global(.px-icon) {
		opacity: 1;
	}

	input:disabled + label {
		cursor: default;
	}

	input:disabled + label > div {
		opacity: 0.5;
	}

	input:disabled + label .checkWrapper {
		opacity: 0.5;
	}
</style>
